import { DAY_IN_MILLIS } from 'src/constants';

export function diffDateDays(date1, date2) {
    const diffTime = Math.abs(date2 - date1);
    return Math.ceil(diffTime / DAY_IN_MILLIS);
}
